// React
import React from 'react';
// 三方库
import { useTranslation } from '@/i18n/client';
// 组件
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';

const ConfirmDialog: React.FC<{
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogContent>
        <DialogContentText>{t('address.siteChange.confirmMessage')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onCancel}>{t('address.cancel')}</Button>
        <Button onClick={onConfirm} autoFocus variant='contained' color='primary' sx={{ boxShadow: 'none' }}>
          {t('address.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
